import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Career() { return <StaticPageRedirect page="career" />; }
